import {
  toNumber2e2hj9zugjwi2 as toNumber,
  numberToLong2pakxeg38estk as numberToLong,
  convertToInty04h231mmjoh as convertToInt,
  fromInt2ii0rejb1w62w as fromInt,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function toDoubleExact(_this__u8e3s4) {
  var result = toNumber(_this__u8e3s4);
  // Inline function 'kotlin.check' call
  if (!(numberToLong(result) === _this__u8e3s4)) {
    var message = _this__u8e3s4.toString() + ' cannot be converted to Double';
    throw IllegalStateException().o(toString(message));
  }
  return result;
}
function toIntExact(_this__u8e3s4) {
  var result = convertToInt(_this__u8e3s4);
  // Inline function 'kotlin.check' call
  if (!(fromInt(result) === _this__u8e3s4)) {
    var message = _this__u8e3s4.toString() + ' cannot be converted to Int';
    throw IllegalStateException().o(toString(message));
  }
  return result;
}
function toIntExact_0(_this__u8e3s4) {
  var result = numberToInt(_this__u8e3s4);
  // Inline function 'kotlin.check' call
  if (!(result === _this__u8e3s4)) {
    var message = '' + _this__u8e3s4 + ' cannot be converted to Int';
    throw IllegalStateException().o(toString(message));
  }
  return result;
}
function toLongExact(_this__u8e3s4) {
  var result = numberToLong(_this__u8e3s4);
  // Inline function 'kotlin.check' call
  if (!(toNumber(result) === _this__u8e3s4)) {
    var message = '' + _this__u8e3s4 + ' cannot be converted to Long';
    throw IllegalStateException().o(toString(message));
  }
  return result;
}
//region block: exports
export {
  toDoubleExact as toDoubleExact18clzpruqqw2d,
  toIntExact as toIntExact1p16u7ro59o31,
  toIntExact_0 as toIntExact1n46an7ryabg9,
  toLongExact as toLongExact9cht6g9si07j,
};
//endregion

//# sourceMappingURL=Utils.mjs.map
